import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

const COOKIE_NAME = 'sb_session';
const COOKIE_DOMAIN = '.shoutout.us';

function setSessionCookie(accessToken: string, refreshToken: string) {
  try {
    const value = JSON.stringify({ access_token: accessToken, refresh_token: refreshToken });
    const maxAge = 60 * 60 * 24 * 365;
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(value)}; domain=${COOKIE_DOMAIN}; path=/; max-age=${maxAge}; secure; samesite=lax`;
  } catch (_) { /* noop */ }
}

function clearSessionCookie() {
  document.cookie = `${COOKIE_NAME}=; domain=${COOKIE_DOMAIN}; path=/; max-age=0; secure; samesite=lax`;
}

function getSessionCookie(): { access_token: string; refresh_token: string } | null {
  try {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
    if (!match) return null;
    return JSON.parse(decodeURIComponent(match[1]));
  } catch (_) {
    return null;
  }
}

function seedLocalStorageFromCookie() {
  const storageKey = 'supabase.auth.token';
  const existingSession = window.localStorage.getItem(storageKey);
  if (existingSession) return;

  const cookieSession = getSessionCookie();
  if (cookieSession?.access_token && cookieSession?.refresh_token) {
    console.log('🔑 Seeding localStorage from cross-domain cookie');
    const sessionData = {
      currentSession: {
        access_token: cookieSession.access_token,
        refresh_token: cookieSession.refresh_token,
        token_type: 'bearer',
      },
      expiresAt: Math.floor(Date.now() / 1000) + 3600,
    };
    window.localStorage.setItem(storageKey, JSON.stringify(sessionData));
  }
}

seedLocalStorageFromCookie();

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: window.localStorage,
    storageKey: 'supabase.auth.token',
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
  global: {
    headers: {
      'X-Client-Info': 'shoutout-web',
    },
  },
});

supabase.auth.onAuthStateChange((_event, session) => {
  if (session?.access_token && session?.refresh_token) {
    setSessionCookie(session.access_token, session.refresh_token);
  } else {
    clearSessionCookie();
  }
});

export default supabase;
